export const config = {
  API_TOKEN: process.env.REACT_APP_API_TOKEN,
  API_NODE: process.env.REACT_APP_API_NODE,
  GATEWAY_API_KEY: process.env.REACT_APP_GATEWAY_API_KEY
};
